import { render, staticRenderFns } from "./NscDetail.vue?vue&type=template&id=1238af8f&scoped=true"
import script from "./NscDetail.vue?vue&type=script&lang=js"
export * from "./NscDetail.vue?vue&type=script&lang=js"
import style0 from "./NscDetail.vue?vue&type=style&index=0&id=1238af8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1238af8f",
  null
  
)

export default component.exports